import * as React from "react";
const SvgProps = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.75 5a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0Zm-1.425.75a3.751 3.751 0 0 0 7.35 0h2.65a3.751 3.751 0 0 0 7.35 0H21a.75.75 0 0 0 0-1.5h-.325a3.751 3.751 0 0 0-7.35 0h-2.65a3.751 3.751 0 0 0-7.35 0H3a.75.75 0 0 0 0 1.5h.325ZM17 2.75a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5Zm-5 11.257c-.358.362-.811.658-1.284.887-1.118.542-2.61.856-4.216.856-.846 0-1.59-.074-2.25-.222V22a.75.75 0 0 1-1.5 0v-7.005a6.567 6.567 0 0 1-.08-.042c-1.004-.536-1.704-1.31-2.296-2.207a.75.75 0 0 1 1.059-1.025c.742.524 2.789 1.076 7.203-1.377.11-.06.37-.204.691-.332.307-.124.737-.262 1.173-.262.633 0 1.138.263 1.5.635a2.054 2.054 0 0 1 1.5-.635c.436 0 .866.138 1.173.262.32.128.582.271.691.332 4.414 2.453 6.462 1.901 7.203 1.377a.75.75 0 0 1 1.059 1.025c-.592.897-1.292 1.67-2.296 2.207-1 .534-2.231.797-3.83.797-1.607 0-3.098-.314-4.216-.856-.473-.23-.926-.525-1.284-.887Zm-5.5.243c-1.117 0-1.95-.143-2.602-.386a.749.749 0 0 0-.24-.098 4.107 4.107 0 0 1-.211-.1c1.493-.066 3.437-.632 5.917-2.01.094-.053.29-.16.522-.252.245-.099.464-.154.614-.154.213 0 .376.094.512.287.15.211.238.514.238.796 0 .287-.264.763-1.188 1.211-.873.423-2.131.706-3.562.706Zm6.25-1.917c0-.282.088-.585.238-.796.136-.193.299-.287.512-.287.15 0 .369.055.614.154.232.093.428.2.522.252 2.48 1.378 4.424 1.944 5.918 2.01-.71.362-1.661.584-3.054.584-1.43 0-2.69-.283-3.562-.706-.924-.448-1.188-.924-1.188-1.21Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgProps;
